import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../common";

export const SidebarLogoutButton = ({ open }) => {
  const history = useNavigate();

  return (
    <ListItem
      disablePadding
      sx={{
        borderRadius: "7px",
        marginBottom: 1.5,
        justifyContent: "center",
      }}
    >
      <ListItemButton onClick={() => logoutUser(history)}>
        <ListItemIcon
          sx={{
            fontSize: { xs: "12px", md: "14px" },
          }}
        >
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText
          primary="Log Out"
          primaryTypographyProps={{
            fontSize: { xs: "12px", md: "14px" },

            color: "black",
          }}
          sx={{ opacity: open ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};
